import React from 'react';

import { Alert, Box, HStack } from '@chakra-ui/react';
import { customTheme } from 'theme';

import { ExclamationTriangleIcon } from 'components/Icons';

interface Props {
  message: string;
  icon?: React.ReactNode;
  align?: string;
}

export const WarningAlert: React.FC<Props> = props => {
  const { message, icon, align = 'flex-start' } = props;
  return (
    <Alert
      status="warning"
      borderRadius={6}
      px={8}
      py={4}
      bg="#fdf8e9"
      borderColor={customTheme.colors.componentBorder}
      border={`1px solid ${customTheme.colors.componentBorder}`}
    >
      <HStack spacing={6} align={align}>
        <Box boxSize={8}>{icon ?? <ExclamationTriangleIcon color="red" />}</Box>
        <Box flex={1} fontSize="sm">
          {message}
        </Box>
      </HStack>
    </Alert>
  );
};
